import { getApp, getApps, initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'
import { getFunctions } from 'firebase/functions'

/**
 * Firebase browser API keys identify the project; they are not credentials.
 * The defaults point at the existing SangMath Firebase project. Vite variables
 * are available for an isolated staging project when needed.
 */
const config = {
  apiKey: import.meta.env.VITE_LEAGUE_FIREBASE_API_KEY || 'AIzaSyDW1VicfdulIH8ttao2SHFDoOrbvmlT6G8',
  authDomain: import.meta.env.VITE_LEAGUE_FIREBASE_AUTH_DOMAIN || 'stexgv.firebaseapp.com',
  projectId: import.meta.env.VITE_LEAGUE_FIREBASE_PROJECT_ID || 'stexgv',
  storageBucket: import.meta.env.VITE_LEAGUE_FIREBASE_STORAGE_BUCKET || 'stexgv.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_LEAGUE_FIREBASE_MESSAGING_SENDER_ID || '919572748061',
  appId: import.meta.env.VITE_LEAGUE_FIREBASE_APP_ID || '1:919572748061:web:989672f83657a3b6ed33f4',
}

const app = getApps().length ? getApp() : initializeApp(config)

export const firebaseAuth = getAuth(app)
export const leagueFunctions = getFunctions(app, import.meta.env.VITE_LEAGUE_FIREBASE_FUNCTION_REGION || 'asia-southeast1')
export const isFirebaseLeagueMode = true
